import React from 'react'

import { CardType } from 'types/deck'

import { CardText, manaArrayToElement } from 'components/misc/customIcons/ManaSymbol/helpers'

import { CardLoaderContainer, TextBox, TitleBox, TypeBox, PTBox, Logo } from './style'
import styles from './cardLoader.module.scss'

type Props = {
  loading?: boolean
  card?: CardType
  className?: string
  style?: React.CSSProperties
  includeName?: boolean
  includeText?: boolean
  includeManaCost?: boolean
  flipped?: boolean
}

const CardLoader = React.forwardRef((props: Props, ref: any) => {
  const {
    loading = false,
    card,
    className,
    style,
    includeName = true,
    includeText = false,
    includeManaCost = false,
    flipped = false,
  } = props

  if (!loading) return null

  let cardFace = card

  if (card?.front && !flipped) cardFace = card.front
  else if (card?.back && flipped) cardFace = card.back

  const name = cardFace?.name || ''
  const castingCost = cardFace?.castingCost || []
  const power = cardFace?.power || ''
  const toughness = cardFace?.toughness || ''
  const loyalty = cardFace?.loyalty || ''

  const superTypes = (cardFace?.superTypes || []).join(' ')
  const types = (cardFace?.types || []).join(' ')
  const subTypes = (cardFace?.subTypes || []).join(' ')

  const typeTextBox = `${superTypes} ${types} ${subTypes.length ? '- ' : ''}${subTypes}`

  const rawText = cardFace?.text || ''

  const nameBoxFontSize = titleBoxFontSizeHelper(name)
  const typeBoxFontSize = titleBoxFontSizeHelper(typeTextBox)
  const textBoxFontSize = textBoxFontSizeHelper(rawText)

  return (
    <CardLoaderContainer ref={ref} className={className} style={style}>
      <TitleBox style={{ opacity: includeName ? 1 : 0 }}>
        <span style={{ fontSize: nameBoxFontSize, fontStyle: !name && !!card?.customCard ? 'italic' : undefined }}>
          {name || (!!card?.customCard ? 'Unknown or removed' : '')}
        </span>
        {includeManaCost && <span className={styles.manaCost}>{manaArrayToElement(castingCost)}</span>}
      </TitleBox>
      <TextBox title={typeTextBox}>
        <div
          title={rawText}
          className={styles.cardText}
          style={{ opacity: includeText ? 1 : 0, fontSize: textBoxFontSize }}>
          <CardText input={rawText} />
        </div>
      </TextBox>
      <TypeBox $typebox style={{ opacity: includeText ? 1 : 0, fontSize: typeBoxFontSize }}>
        {typeTextBox}
      </TypeBox>
      {includeText && types.includes('Creature') && (
        <PTBox>
          {power || 0} / {toughness || 0}
        </PTBox>
      )}

      {includeText && types.includes('Planeswalker') && !types.includes('Creature') && <PTBox>{loyalty || 0}</PTBox>}
      <Logo />
    </CardLoaderContainer>
  )
})

export default CardLoader

const titleBoxFontSizeHelper = (text: string): number => {
  if (text.length < 25) return 12
  if (text.length < 35) return 11
  if (text.length < 45) return 10
  if (text.length < 55) return 9
  if (text.length < 65) return 8

  return 7
}

const textBoxFontSizeHelper = (text: string): number => {
  if (text.length < 100) return 12
  if (text.length < 15) return 11
  if (text.length < 200) return 10
  if (text.length < 250) return 9
  if (text.length < 300) return 8

  return 7
}
